// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"oh_a bha_px bha_a bha_w","FaqAskQuestion__outdated":"oh_b bha_ul bha_vz"};